import { Link } from "react-router-dom";
import AuthForm from "../../components/authForm/authForm";
import InputField from "../../components/inputField/inputField";
import PrimaryBtn from "../../components/primaryButton/primaryBtn";
import { useEffect } from "react";

const SignUp = (props) => {
  const { setIsActive } = props;
  const getUserEmail = (event) => {
    console.log(event.target.value);
  };
  const getUserPassword = (event) => {
    console.log(event.target.value);
  };
  const getUserName = (event) => {
    console.log(event.target.value);
  };
  const onSubmit = () => {};
  const signUpForm = () => {
    return (
      <div className="px-4">
        <form className="authentication-form">
          <div className="mb-3">
            <label className="form-label">Name</label>
            <InputField type="name" placeholder="Enter your name" changeEvent={getUserName} />
          </div>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <InputField type="email" placeholder="Enter your email" changeEvent={getUserEmail} />
          </div>
          <div className="mb-3">
            <label className="form-label">Password</label>
            <InputField type="text" placeholder="Enter your password" changeEvent={getUserPassword} />
          </div>
          <div className="mb-3">
            <div className="form-check">
              <input type="checkbox" className="form-check-input" id="checkbox-signin" />
              <label className="form-check-label" htmlFor="checkbox-signin">
                I accept Terms and Condition
              </label>
            </div>
          </div>

          <div className="mb-1 text-center d-grid">
            <PrimaryBtn type="submit" submitBtn={onSubmit}>
              Create Account
            </PrimaryBtn>
          </div>
        </form>
        <p className="mt-3 fw-semibold no-span">OR sign with</p>

        <div className="text-center">
          <a href="javascript:void(0);" className="btn btn-outline-light shadow-none">
            <i className="bx bxl-google fs-20"></i>
          </a>
          <a href="javascript:void(0);" className="btn btn-outline-light shadow-none">
            <i className="ri-facebook-fill fs-20"></i>
          </a>
          <a href="javascript:void(0);" className="btn btn-outline-light shadow-none">
            <i className="bx bxl-github fs-20"></i>
          </a>
        </div>
      </div>
    );
  };

  useEffect(() => {
    setIsActive(false);
    return () => {
      setIsActive(true);
    };
  }, []);

  return (
    <section className="authentication-bg">
      <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-5">
              <AuthForm title="Free Account" subtitle="New to our platform? Sign up now! It only takes a minute." form={signUpForm} />
              <p className="mb-0 text-center text-white">
                I already have an account
                <Link to="/signin" className="text-reset text-unline-dashed fw-bold ms-1">
                  Sign In
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignUp;
